import { RootState } from 'store';
import { createSelector } from '@reduxjs/toolkit';

const selectWeeklyReportState = (state: RootState) => state.weeklyReport;
export const selectWeeklyReportStatuses = createSelector(
  selectWeeklyReportState,
  ({ isLoading, isMounted }) => {
    return { isLoading, isMounted };
  },
);
export const selectWeeklyReportFilters = createSelector(
  selectWeeklyReportState,
  ({ filters }) => {
    return filters
  },
);
export const selectWeeklyReportData = createSelector(
  selectWeeklyReportState,
  ({ data }) => {
    return data
  },
);
